import { Component, Injectable } from '@angular/core';
import { NgbDatepickerI18n, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';


type SupportedLanguage = 'fr' | 'es';

const I18N_VALUES: Record<SupportedLanguage, { weekdays: string[]; months: string[] }> = {
  'fr': {
    weekdays: ['Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa', 'Di'],
    months: ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Juin', 'Juil', 'Aou', 'Sep', 'Oct', 'Nov', 'Déc'],
  },
  'es': {
    weekdays: ['Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa', 'Do'],
    months: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
  },
};

@Injectable()
export class I18n {
  language = 'es';
}

@Injectable()
export class DatepickerLocalizationService extends NgbDatepickerI18n {
  constructor(private _i18n: I18n) {
    super();
  }
  override getWeekdayLabel(weekday: number, width?: Exclude<Intl.DateTimeFormatOptions['weekday'], undefined>): string {
    return I18N_VALUES[this._i18n.language as SupportedLanguage].weekdays[weekday - 1];
  }
  override getMonthShortName(month: number, year?: number): string {
    return I18N_VALUES[this._i18n.language as SupportedLanguage].months[month - 1];
  }
  override getMonthFullName(month: number, year?: number): string {
    return this.getMonthShortName(month, year);
  }
  override getDayAriaLabel(date: NgbDateStruct): string {
    return `${date.day}-${this.getMonthFullName(date.month)}-${date.year}`;
  }


}